import { render, staticRenderFns } from "./AuvDashboardWidget.vue?vue&type=template&id=30dbf0c6&scoped=true"
import script from "./AuvDashboardWidget.vue?vue&type=script&lang=js"
export * from "./AuvDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./AuvDashboardWidget.vue?vue&type=style&index=0&id=30dbf0c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dbf0c6",
  null
  
)

export default component.exports